export enum ResponsiveDropdownComponentForceModeType{
    Dropdown='dropdown',
    BottomSheet='bottom-sheet'
}
